import React from 'react';
import './ApexFeatures.css';
import apexPreviewVideo from './assets/apex preview script.mov';
import { Trans, useTranslation } from 'react-i18next';  // useTranslation hinzugefügt
import { GrShieldSecurity, GrNetwork, GrCpu } from "react-icons/gr";

const ApexFeatures = () => {
  useTranslation();  // sorgt für Re-Render bei Sprachwechsel
  return (
    <div className="apex_features-component" id="apex-features">
      <div className="apex_features-left">
        <video
          src={apexPreviewVideo}
          className="apex_features-video"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
      <div className="apex_features-right">
        <h2>
          <Trans
            i18nKey="apex_features_heading"
            components={{ br: <br /> }}
          />
        </h2>
        <p>
          <Trans
            i18nKey="apex_features_description"
            components={{ highlight: <span style={{ color: "#fd314a" }} /> }}
          />
        </p>
        
        {/* Apex Feature boxes */}
        <div className="apex-features-info-blocks">
          <div className="apex-features-info-block">
            <GrShieldSecurity className="apex-features-info-icon" />
            <div className="apex-features-info-text">
              <p>Private builds that are individually encrypted.</p>
            </div>
          </div>
          <div className="apex-features-info-block">
            <GrNetwork className="apex-features-info-icon" />
            <div className="apex-features-info-text">
              <p>No interaction with any game files, no injections!</p>
            </div>
          </div>
          <div className="apex-features-info-block">
            <GrCpu className="apex-features-info-icon" />
            <div className="apex-features-info-text">
              <p>MAKCU Board performs recoil compensation.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApexFeatures;